import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Trophy, Coins, Clock, ShieldCheck, Gift } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import HowItWorks from "../components/HowItWorks";
import { ROOBET_LINK } from "../mock";

const faqs = [
  {
    Icon: Trophy,
    q: "What is the wager race?",
    a: "Every month we run a leaderboard race. Your total (weighted) amount wagered on Roobet under code BROER decides your position. The higher you climb, the bigger your share of the prize pool.",
  },
  {
    Icon: Coins,
    q: "How are the prizes paid out?",
    a: "At the end of each month the top players receive their prize directly on their Roobet balance. The prize per position is shown live on the leaderboard.",
  },
  {
    Icon: Clock,
    q: "When does it reset?",
    a: "The race resets at the start of every calendar month. Previous months stay available under 'Previous Leaderboards' so you can always check past results.",
  },
  {
    Icon: ShieldCheck,
    q: "How is wagering tracked?",
    a: "As long as you signed up with code BROER, your wagers are tracked automatically through the official Roobet affiliate system. No manual steps needed.",
  },
  {
    Icon: Gift,
    q: "What else do I get?",
    a: "Beyond the race you get instant rakeback, exclusive community giveaways, VIP transfer perks and access to the Discord community.",
  },
];

const HowItWorksPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#2f2753]">
      <Header />
      <main className="pt-28">
        <section className="px-5 pt-10 pb-6">
          <div className="max-w-5xl mx-auto">
            <Link to="/" className="inline-flex items-center gap-2 text-[#b7b0d6] hover:text-white font-semibold transition-colors mb-8">
              <ArrowLeft size={18} /> Back to home
            </Link>
            <div className="text-center">
              <p className="text-[#edbb23] font-extrabold tracking-[0.3em] text-sm mb-3">GET STARTED</p>
              <h1 className="text-4xl md:text-6xl font-black text-white tracking-tight">How Does It Work?</h1>
              <p className="mt-5 text-[#b7b0d6] max-w-2xl mx-auto leading-relaxed">
                Joining the Broer community and competing for the monthly prize pool takes just a few minutes.
                Here's everything you need to know.
              </p>
            </div>
          </div>
        </section>

        {/* steps */}
        <HowItWorks showHeader={false} />

        {/* FAQ / detail */}
        <section className="px-5 py-20 bg-[#2f2753]">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-black text-white text-center mb-12">Everything Explained</h2>
            <div className="space-y-4">
              {faqs.map((f) => (
                <div key={f.q} className="rounded-2xl bg-[#342b60] border border-[#473c7d] p-6">
                  <div className="flex items-start gap-4">
                    <div className="shrink-0 w-11 h-11 rounded-xl bg-[#edbb23] flex items-center justify-center text-[#251e44]">
                      <f.Icon size={22} />
                    </div>
                    <div>
                      <h3 className="text-lg font-extrabold text-white mb-1">{f.q}</h3>
                      <p className="text-[#b7b0d6] leading-relaxed text-sm">{f.a}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="text-center mt-12">
              <a
                href={ROOBET_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-[#edbb23] hover:bg-[#f4cf52] text-[#251e44] font-extrabold rounded-xl px-8 h-14 transition-colors"
              >
                <img src="/assets/roobet-dark.png" alt="" className="w-5 h-5 object-contain" /> SIGN UP WITH CODE BROER
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default HowItWorksPage;
